import { Regola } from "./../../../../models/document/quoting-model";
import { LavorazioniComponents } from "./../../../../models/document/quoting-model";

export class ExcludingComponent {
    components: LavorazioniComponents = new LavorazioniComponents();

    // get name of model item from sezione value
    private Macrocategory: string;

    getMacrocategory() {
        return this.Macrocategory;
    }

    setMacrocategory(macrocategory) {
        this.Macrocategory = macrocategory;
    }

    getModelItemName(sezione) {
        switch (sezione) {
            case "formato":
                {
                    return "formato";
                }

            case "copertina":
                {
                    return "";
                }

            case "fustellatura":
                {
                    return "";
                }

            case "plastificazione":
                {
                    return "plastificazioni1";
                }

            case "plastificazione_copertina":
                {
                    return "plastificazioni2";
                }

            case "rilegatura":
                {
                    return "rilegature";
                }

            case "taglio":
                {
                    return "tagli";
                }

            default:
                {
                    return "";
                }
        }
    }

    //remove all excluding rules from model
    removeSelectRules(model) {
        for (var key in model) {
            if (model[key] != null) {
                if (this.getLowerCase(key) == "lavorazioniaccessorie")     // if lavorazione then remove this whay
                {
                    for (var lavorazioneKey in model[key]) // for each key in lavorazione model we set that visible is true
                    {
                        model[key][lavorazioneKey].isVisible = true;

                        for (var subKey in model[key][lavorazioneKey].valori) // also for each item in valori(drop down)                        
                        {
                            try {
                                model[key][lavorazioneKey].valori[subKey].isVisible = true;
                            }
                            catch (Exception) { }
                        }
                    }
                }

                else {
                    for (var subKey in model[key])   // set all keys to visible
                    {
                        try {
                            if (Array.isArray(model[key])) {
                                model[key][subKey].isVisible = true;
                            }

                            model.tipoTaglio = true;
                        }

                        catch (Exception) { }
                    }
                }

            }
        }

        return model;
    }

    // remove excluding rules from one component
    // if is lavorazione we need to remove rull from model.lavorazione not from model

    removeRuleFromComponent(model, component, lavorazione = false) {
        if (model != null && model != undefined) {
            if (!lavorazione) {
                for (var key in model[component]) {
                    try {
                        model[component][key].isVisible = true;
                    }

                    catch (Exception) { }
                }
            }

            else {
                for (var subKey in model.lavorazioniAccessorie) {
                    for (var valoriSubKey in model.lavorazioniAccessorie[subKey].valori) {
                        try {
                            model.lavorazioniAccessorie[subKey].valori[valoriSubKey].isVisible = true;
                        }

                        catch (Exception) { }
                    }
                }
            }
        }

        return model;
    }

    // remove excluding rules list
    removeSelectRuleFromList(model, regoles) {
        for (var regoleKey in regoles) {
            switch (this.getLowerCase(regoles[regoleKey].Categoria_2)) {
                case "accessoria":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Id_Elemento_2));
                        model = this.removeRuleFromComponent(model, component, true);
                        break;
                    }

                case "finitura":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Sezione_2));
                        model = this.removeRuleFromComponent(model, component);
                        break;
                    }

                case "carte":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Categoria_2));
                        model = this.removeRuleFromComponent(model, component);
                        break;
                    }

                case "carte_copertina":
                    {
                        var component = this.getModelItemName(this.getLowerCase(regoles[regoleKey].Categoria_2));
                        model = this.removeRuleFromComponent(model, component);
                        break;
                    }

                default: { }
            }
        }

        return model;
    }

    // return  rules list for certain category
    filter(list, field, value) {
        var returnList = new Array<Regola>();

        for (var key in list) {
            var text = "";
            try {
                text = this.getLowerCase(list[key][field]);
            }
            catch (exception) { }

            if (text == this.getLowerCase(value)) {
                returnList.push(list[key]);
            }
        }

        return returnList;
    }

    // return excluding rules for custom categoria and sezione
    getRegole(regolesList, categoria, sezione) {
        var allRegoles = regolesList;
        var regoles = null;

        if (allRegoles != null && allRegoles != undefined && allRegoles.length > 0)      // check if we have regoles
        {
            var categoryRegoles = this.filter(allRegoles, "Categoria_1", categoria);        //get regoles for certain cattegory
            if (categoryRegoles != null && categoryRegoles != undefined && categoryRegoles.length > 0) {
                var regoles = null;

                //get regoles for certain cattegory
                switch (this.getLowerCase(categoria)) {
                    case "finiture":
                        {
                            regoles = this.filter(categoryRegoles, "Sezione_1", sezione);

                            for (var regolesKey in regoles) {
                                var sezioneInput = this.getModelItemName(this.getLowerCase(regoles[regolesKey].Sezione_2));  //return name for current rules 
                            }
                            break;
                        }
                    case "accessoria":
                        {
                            regoles = this.filter(categoryRegoles, "Id_Elemento_1", sezione);

                            for (var regolesKey in regoles) {
                                var sezioneInput = this.getModelItemName(this.getLowerCase(regoles[regolesKey].Sezione_2));
                            }

                            break;
                        }

                    default:
                        {
                            regoles = categoryRegoles;
                        }
                }

                if (sezione == "") {
                    regoles = categoryRegoles;
                }
                else { }
            }
        }

        return regoles;
    }

    getLavorazioneValue(lavorazione, tipo, id)   //get value for current state if we get fisso for example than check box is checkd
    {
        try {
            var tipoNum = parseInt(tipo);
            switch (tipoNum) {
                case this.components.checkBox:
                    {
                        if (lavorazione.value == null || lavorazione.value == undefined) {
                            switch (lavorazione.tipoSelezione) {
                                case "non_selezionato":
                                    {
                                        lavorazione.value = false;
                                        return lavorazione.value;
                                    }

                                case "selezionato":
                                    {
                                        lavorazione.value = true;
                                        return lavorazione.value;
                                    }

                                case "fisso":
                                    {
                                        lavorazione.value = true;
                                        return lavorazione.value;
                                    }


                                case "nascosto":
                                    {
                                        lavorazione.value = true;
                                        return lavorazione.value;
                                    }

                                default:
                                    {
                                        lavorazione.value = false;
                                        return lavorazione.value;
                                    }
                            }
                        }
                        else {
                            return !lavorazione.value;
                        }
                    };

                case this.components.selectBox:
                    { };

                case this.components.inputBox:
                    { }

                default:
                    {
                        return null;
                    }
            }
        }

        catch (exception) { }
    }

    // hidding field for finiture category

    //regole - because we need element to hide.
    hideFinituraValue(model, component, regole, macro) {
        switch (this.getLowerCase(macro)) {
            case "editoria":
                {
                    for (var key in model[component]) {
                        if (model[component][key].chiave == regole.Id_Elemento_2) {
                            model[component][key].isVisible = false;
                        }
                    }

                    if (component == "taglio") {
                        model[component] = false;
                        model.tipoTaglio = false;
                    }
                }
        }

        return model;
    }

    //not finished, method that hode lavorazine
    hideLavorazioneValue(model, component, regole, macro) {
        switch (this.getLowerCase(macro)) {
            case "editoria":
                {
                    for (var key in model.lavorazioniAccessorie) {
                        try {
                            if (model.lavorazioniAccessorie[key] != null) {
                                if (model.lavorazioniAccessorie[key].id == component) {
                                    if (parseInt(model.lavorazioniAccessorie[key].tipo) == this.components.selectBox) {
                                        for (var subKey in model.lavorazioniAccessorie[key].valori) {
                                            if (model.lavorazioniAccessorie[key].valori[subKey].chiave == regole.Id_Elemento_Sottochiave_2) {
                                                model.lavorazioniAccessorie[key].valori[subKey].isVisible = false;
                                                model.lavorazioniAccessorie[key].valori[subKey].chiave = 0;
                                            }
                                        }
                                    }

                                    else if (model.lavorazioniAccessorie[key].tipo == this.components.checkBox) {
                                        model.lavorazioniAccessorie[key].value = false;
                                        model.lavorazioniAccessorie[key].isVisible = false;
                                    }

                                    else if (model.lavorazioniAccessorie[key].tipo == this.components.inputBox) {
                                        model.lavorazioniAccessorie[key].value = "";
                                        model.lavorazioniAccessorie[key].isVisible = false;;
                                    }
                                }
                            }
                        }
                        catch (Exception) { }
                    }
                }
        }

        return model;
    }

    /// hidding option from regole id_element2
    hideSelectValue(model, regole, macro, elemento)   // switch that determine witch hiden method need to use , for all hide group we need method
    {
        switch (this.getLowerCase(regole.Categoria_2)) {
            case "carta":
            case "carta copertina": { }
            case "finitura":
                {
                    var sezioneInput = this.getModelItemName(this.getLowerCase(regole.Sezione_2));
                    model = this.hideFinituraValue(model, sezioneInput, regole, macro);
                }

            case "accessoria":
                {
                    if (this.getLowerCase(regole.Categoria_1) == "accessoria") {
                        for (var key in model.lavorazioniAccessorie) {
                            if (model.lavorazioniAccessorie[key].tipo == this.components.checkBox && model.lavorazioniAccessorie[key].id == regole.Id_Elemento_1) {
                                if ((model.lavorazioniAccessorie[key].value == false && regole.Id_Elemento_Sottochiave_1 == 2) || (model.lavorazioniAccessorie[key].value == true && regole.Id_Elemento_Sottochiave_1 == 1) || regole.Id_Elemento_Sottochiave_1 == 0) {
                                    model = this.hideLavorazioneValue(model, this.getLowerCase(regole.Id_Elemento_2), regole, macro);
                                }
                            }

                            else if (model.lavorazioniAccessorie[key].tipo != this.components.checkBox) { }
                        }
                    }

                    else {
                        model = this.hideLavorazioneValue(model, this.getLowerCase(regole.Id_Elemento_2), regole, macro);
                    }
                }

            case "busta": { }
            default: { }
        }

        return model;
    }

    //method to get lower case in implement method we get error for null etc
    getLowerCase(inputString) {
        var outString = "";

        try {
            outString = inputString.toLowerCase();
        }

        catch (Exception) {
            outString = inputString;
        }

        return outString;
    }

    //     Get excluding rules for certain component, and from category_1 choise witch
    setSelectRules(model, rulesList, categoria, sezione, elemento, sotoelemento, macro) {
        var regoleList = this.getRegole(rulesList, categoria, sezione);

        if (regoleList) // != null && regoles != undefined && regoles.length > 0
        {
            var regole = null;
            if (this.getLowerCase(categoria) == "accessoria") {
                if (elemento == true) {  // return value before 
                    elemento = 1;
                }

                else {
                    elemento = 0;
                }

                regole = regoleList;

                if (!regole) {
                    regole = this.filter(regoleList, "Id_Elemento_Sottochiave_1", "");
                }

            }

            else {
                regole = this.filter(regoleList, "Id_Elemento_1", elemento);
                if (!regole) {
                    regole = this.filter(regoleList, "Id_Elemento_1", "");
                }
            }

            if (regole) {
                for (var regoleKey in regole) {
                    model = this.hideSelectValue(model, regole[regoleKey], macro, elemento);
                }
            }

            else { }
        }

        else { }

        return model;
    }

    /// <param name="tipo">"PF" </param>
    /// <param name="categoria">"FINITURA"</param>
    /// <param name="sezione">"FORMATO"</param>
    /// <param name="macroCategoria">"EDITORIA"</param>
    /// <param name="elemento">null </param>
    /// <param name="sottoElemento">null</param>
    ResetRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct = []) {
        let regoleToReset = this.FindRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel);
        let flagReset;

        for (let regola of regoleToReset) {
            if (this.CheckMacroCategoria(regola, this.Macrocategory)) {
                flagReset = true;
                this.ApplicaRegola(regola, flagReset, responseModel, responseModelOtherProduct);
            }
        }
    }

    ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct = []) {
        //console.log("ApplicaRegole");
        let regoleToApply = this.FindRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel);
        let flagReset;

        for (let regola of regoleToApply) {
            //console.log(regola)
            if (this.CheckMacroCategoria(regola, this.Macrocategory)) {
                flagReset = false;
                this.ApplicaRegola(regola, flagReset, responseModel, responseModelOtherProduct);
            }
        }
    }


    ApplicaRegola(regola, flagReset, responseModel, responseModelOtherProduct = []) {
        let hideOrShow;

        if (flagReset == false) {
            hideOrShow = "hide";
        }

        else {
            hideOrShow = "show";
        }

        if (regola.Tipo_Regola == "ESCLUDE") {
            if (regola.Categoria_2 == "CARTA") {
                //In questo caso è stata esclusa una carta e/o grammatura
                var idElemento = regola.Id_Elemento_2;
                var idSottoElemento = regola.Id_Elemento_Sottochiave_2;

                //Se la sottochiave non è valorizzata bisogna escludere l'intera carta, 
                //altrimenti una singola grammatura (solo per la relativa carta)
                if (idSottoElemento == null || idSottoElemento == 0) {
                    var attributo = regola.Categoria_2;
                    this.hideOrShowComboItem("CARTA", idElemento, hideOrShow, responseModel);
                }

                else {
                    if (responseModel.idCarte1 != null) {
                        var data = responseModel.idCarte1.split("_");
                        let idCarta = data[0];
                        //Se la carta scelta è quella della regola, allora viene nascosta la grammatura

                        if (idCarta == idElemento) {
                            this.hideOrShowComboItem("GRAMMATURA_CARTA", idSottoElemento, hideOrShow, responseModel);
                        }
                    }
                }
            }

            else if (regola.Categoria_2 == "CARTA_COPERTINA") {
                //In questo caso è stata esclusa una carta e/o grammatura
                var idElemento = regola.Id_Elemento_2;
                var idSottoElemento = regola.Id_Elemento_Sottochiave_2;

                //Se la sottochiave non è valorizzata bisogna escludere l'intera carta, 
                //altrimenti una singola grammatura (solo per la relativa carta)
                if (idSottoElemento == null || idSottoElemento == 0) {
                    var attributo = regola.Categoria_2;
                    this.hideOrShowComboItem("CARTA_COPERTINA", idElemento, hideOrShow, responseModel);
                }

                else {
                    if (responseModel.idCarte2 != null) {
                        var data = responseModel.idCarte2.split("_");
                        let idCarta = data[0];
                        //Se la carta scelta è quella della regola, allora viene nascosta la grammatura
                        if (idCarta == idElemento) {
                            this.hideOrShowComboItem("GRAMMATURA_CARTA_COPERTINA", idSottoElemento, hideOrShow, responseModel);
                        }
                    }
                }
            }

            else if (regola.Categoria_2 == "FINITURA") {
                let sezione = regola.Sezione_2;
                let idElemento = regola.Id_Elemento_2;

                if (sezione == "TAGLIO") {
                    this.hideOrShowAttribute("TAGLIO", hideOrShow, responseModel);
                }

                else if (sezione == "STAMPA_BIFACCIALE") {
                    this.hideOrShowComboItem(sezione, idElemento, hideOrShow, responseModel);
                }

                else if (sezione == "BIANCO_COPRENTE") {
                   
                    if (idElemento == "1") {
                        this.hideOrShowComboItem(sezione, "0", hideOrShow, responseModel);
                    }

                    else if (idElemento == "2") {
                        this.hideOrShowComboItem(sezione, "1", hideOrShow, responseModel);
                    }

                    else if (idElemento == "3") {
                        this.hideOrShowComboItem(sezione, "2", hideOrShow, responseModel);
                    }
                }

                else {
                    this.hideOrShowComboItem(sezione, idElemento, hideOrShow, responseModel);
                }
            }

            else if (regola.Categoria_2 == "SUPPORTO_RIGIDO") {
                //In questo caso è stato escluso un supporto rigido
                var idElemento = regola.Id_Elemento_2;

                this.hideOrShowComboItem("SUPPORTO_RIGIDO", idElemento, hideOrShow, responseModel);
            }

            else if (regola.Categoria_2 == "MATERIALE_FLESSIBILE") {
                //In questo caso è stato escluso un supporto rigido
                var idElemento = regola.Id_Elemento_2;
                this.hideOrShowComboItem("MATERIALE_FLESSIBILE", idElemento, hideOrShow, responseModel);
            }

            else if (regola.Categoria_2 == "ACCESSORIA") {
                var idLavorazione = regola.Id_Elemento_2;
                var idVariante = regola.Id_Elemento_Sottochiave_2;
                this.hideOrShowLavorazioneAccessoria(idLavorazione, idVariante, hideOrShow, responseModel, responseModelOtherProduct);
            }
        }
    }

    hideOrShowAttribute(attributo, hideOrShow, responseModel) {
        if (attributo == "TAGLIO") {
            if (hideOrShow == "hide") {
                responseModel.isTaglioVisible = true;
            }

            else if (hideOrShow == "show") {
                responseModel.isTaglioVisible = false;
            }
        }
    }

    hideOrShowComboItem(attributo, id, hideOrShow, responseModel) {
        //console.log("hideOrShowComboItem")
        //console.log(this.Macrocategory)
        //console.log(id)
        //console.log(hideOrShow)
        //console.log(attributo)
        //console.log("finehideOrShowComboItem")

        if (this.Macrocategory == "EDITORIA") {
            if (attributo == "CARTA") {
                this.hideOrShowRadComboItem(responseModel.carte1, "CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "CARTA_COPERTINA") {
                this.hideOrShowRadComboItem(responseModel.carte2, "CARTA_COPERTINA", id, hideOrShow, responseModel);
            }
            else if (attributo == "GRAMMATURA_CARTA") {
                this.hideOrShowRadComboItem(responseModel.grammature1, "GRAMMATURA_CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "GRAMMATURA_CARTA_COPERTINA") {
                this.hideOrShowRadComboItem(responseModel.grammature2, "GRAMMATURA_CARTA_COPERTINA", id, hideOrShow, responseModel);
            }
            else if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "PLASTIFICAZIONE_COPERTINA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni2, "PLASTIFICAZIONE_COPERTINA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni2, "PLASTIFICAZIONE_COPERTINA", id, hideOrShow, responseModel);
                }

            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "COPERTINA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.copertine, "COPERTINA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.copertine, "COPERTINA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "RILEGATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.rilegature, "RILEGATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.rilegature, "RILEGATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "COMMERCIALE") {
            if (attributo == "CARTA") {
                this.hideOrShowRadComboItem(responseModel.carte1, "CARTA", id, hideOrShow, responseModel);
            }

            else if (attributo == "GRAMMATURA_CARTA") {
                this.hideOrShowRadComboItem(responseModel.grammature1, "GRAMMATURA_CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "PIEGATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.piegature, "PIEGATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.piegature, "PIEGATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "ETICHETTE") {
            if (attributo == "CARTA") {
                this.hideOrShowRadComboItem(responseModel.carte1, "CARTA", id, hideOrShow, responseModel);
            }

            else if (attributo == "GRAMMATURA_CARTA") {
                this.hideOrShowRadComboItem(responseModel.grammature1, "GRAMMATURA_CARTA", id, hideOrShow, responseModel);
            }
            else if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "FUSTELLATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.tagli, "FUSTELLATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.tagli, "FUSTELLATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "ADESIVI" || this.Macrocategory == "MANIFESTI" || this.Macrocategory == "PANNELLI" || this.Macrocategory == "STAMPA_DIRETTA") {
            if (attributo == "PLASTIFICAZIONE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutte le plastificazioni
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.plastificazioni1, "PLASTIFICAZIONE", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.plastificazioni1, "PLASTIFICAZIONE", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "SUPPORTO_RIGIDO") {
                this.hideOrShowRadComboItem(responseModel.supportiRigidi, "SUPPORTO_RIGIDO", id, hideOrShow, responseModel);
            }
            else if (attributo == "MATERIALE_FLESSIBILE") {
                this.hideOrShowRadComboItem(responseModel.materialiFlessibili, "MATERIALE_FLESSIBILE", id, hideOrShow, responseModel);
            }
            else if (attributo == "BIANCO_COPRENTE") {
                //Se l'id dell'elemento non è settato vengono nascoste tutto il bianco coprente
                this.hideOrShowRadComboItem(responseModel.biancoCoprente, "BIANCO_COPRENTE", id, hideOrShow, responseModel);
            }
            else if (attributo == "STAMPA_BIFACCIALE") {
                if (hideOrShow == "hide") {
                    if (id == "1") {
                        responseModel.isStampaBifaccialeNoHide = true;
                        responseModel.tipoBifacciale="1";
                    }
                    else {
                        responseModel.isStampaBifaccialeSiHide = true;
                        responseModel.tipoBifacciale="0";
                    }
                }
                else {
                    responseModel.isStampaBifaccialeNoHide = false;
                    responseModel.isStampaBifaccialeSiHide = false;
                }
               
            }
            else if (attributo == "FUSTELLATURA") {
                //Se l'id dell'elemento non è settato vengono nascosti tutti gli elementi tranne quello di default
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.tagli, "FUSTELLATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.tagli, "FUSTELLATURA", id, hideOrShow, responseModel);
                }
            }
        }
        else if (this.Macrocategory == "BANDIERE" || this.Macrocategory == "BANNER") {
            if (attributo == "FORMATO") {
                this.hideOrShowRadComboItem(responseModel.formati, "FORMATO", id, hideOrShow, responseModel);
            }
            else if (attributo == "OCCHIELLATURA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.occhielli, "OCCHIELLATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.occhielli, "OCCHIELLATURA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "ASOLA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.asole, "ASOLA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.asole, "ASOLA", id, hideOrShow, responseModel);
                }

            }
            else if (attributo == "CUCITURA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.cuciture, "CUCITURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.cuciture, "CUCITURA", id, hideOrShow, responseModel);
                }
            }
            else if (attributo == "ELETTROSALDATURA") {
                if (id == "0") {
                    this.hideOrShowAllRadComboItems(responseModel.elettrosaldature, "ELETTROSALDATURA", hideOrShow, responseModel);
                }
                else {
                    this.hideOrShowRadComboItem(responseModel.elettrosaldature, "ELETTROSALDATURA", id, hideOrShow, responseModel);
                }

            }
            else if (attributo == "MATERIALE_FLESSIBILE") {
                this.hideOrShowRadComboItem(responseModel.materialiFlessibili, "MATERIALE_FLESSIBILE", id, hideOrShow, responseModel);
            }
        }
    }

    hideOrShowAllRadComboItems(parameterList, tipo, hideOrShow, responseModel) {
        var emptyValue;

        if (tipo == "COPERTINA") {
            emptyValue = "0";
        }
        else {
            emptyValue = "-1"
        }

        let selected = false;

        for (let parameter of parameterList) {
            if (hideOrShow == "show") {
                parameter.isVisible = true;
                if (selected == false) {
                    if (tipo == "RILEGATURA") {
                        if (responseModel.idRilegature == "-1") {
                            responseModel.idRilegature = parameter.chiave;
                        }
                    }
                    else if (tipo == "PIEGATURA") {
                        if (responseModel.idPiegature == "-1") {
                            responseModel.idPiegature = parameter.chiave;
                        }
                    }
                    else if (tipo == "OCCHIELLATURA") {
                        if (responseModel.idOcchielli == "-1") {
                            responseModel.idOcchielli = parameter.chiave;
                        }
                    }
                    else if (tipo == "CUCITURA") {
                        if (responseModel.idCuciture == "-1") {
                            responseModel.idCuciture = parameter.chiave;
                        }
                    }
                    else if (tipo == "ELETTROSALDATURA") {
                        if (responseModel.idElettrosaldature == "-1") {
                            responseModel.idElettrosaldature = parameter.chiave;
                        }
                    }
                    else if (tipo == "ASOLA") {
                        if (responseModel.idAsole == "-1") {
                            responseModel.idAsole = parameter.chiave;
                        }
                    }
                    else if (tipo == "FUSTELLATURA") {
                        if (responseModel.idTagli == "-1") {
                            responseModel.idTagli = parameter.chiave;
                        }
                    }
                    else if (tipo == "PLASTIFICAZIONE") {
                        if (responseModel.idPlastificazioni1 == "-1") {
                            responseModel.idPlastificazioni1 = parameter.chiave;
                        }
                    }
                    else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                        if (responseModel.idPlastificazioni2 == "-1") {
                            responseModel.idPlastificazioni2 = parameter.chiave;
                        }
                    }
                    else if (tipo == "COPERTINA") {
                        if (responseModel.idCopertine == "-1") {
                            responseModel.idCopertine = parameter.chiave;
                        }
                    }

                    selected = true;
                }
            }
            else if (hideOrShow == "hide") {
                if (parameter.chiave != emptyValue) {
                    parameter.isVisible = false;
                }
                else {
                    if (selected == false && parameter.isVisible == true) {
                        if (tipo == "RILEGATURA") {
                            if (responseModel.idRilegature == emptyValue) {
                                responseModel.idRilegature = parameter.chiave;
                            }
                        }
                        else if (tipo == "PIEGATURA") {
                            if (responseModel.idPiegature == emptyValue) {
                                responseModel.idPiegature = parameter.chiave;
                            }
                        }
                        else if (tipo == "OCCHIELLATURA") {
                            if (responseModel.idOcchielli == emptyValue) {
                                responseModel.idOcchielli = parameter.chiave;
                            }
                        }
                        else if (tipo == "CUCITURA") {
                            if (responseModel.idCuciture == emptyValue) {
                                responseModel.idCuciture = parameter.chiave;
                            }
                        }
                        else if (tipo == "ELETTROSALDATURA") {
                            if (responseModel.idElettrosaldature == emptyValue) {
                                responseModel.idElettrosaldature = parameter.chiave;
                            }
                        }
                        else if (tipo == "ASOLA") {
                            if (responseModel.idAsole == emptyValue) {
                                responseModel.idAsole = parameter.chiave;
                            }
                        }
                        else if (tipo == "FUSTELLATURA") {
                            if (responseModel.idTagli == emptyValue) {
                                responseModel.idTagli = parameter.chiave;
                            }
                        }
                        else if (tipo == "PLASTIFICAZIONE") {
                            if (responseModel.idPlastificazioni1 == emptyValue) {
                                responseModel.idPlastificazioni1 = parameter.chiave;
                            }
                        }
                        else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                            if (responseModel.idPlastificazioni2 == emptyValue) {
                                responseModel.idPlastificazioni2 = parameter.chiave;
                            }
                        }
                        else if (tipo == "COPERTINA") {
                            if (responseModel.idCopertine == emptyValue) {
                                responseModel.idCopertine = parameter.chiave;
                            }
                        }

                        selected = true;
                    }
                }
            }
            if (selected == false) {
                if (tipo == "RILEGATURA") {
                    responseModel.idRilegature = "-1";
                }
                else if (tipo == "PIEGATURA") {
                    responseModel.idPiegature = "-1";
                }
                else if (tipo == "FUSTELLATURA") {
                    responseModel.idTagli = "-1";
                }
                else if (tipo == "OCCHIELLATURA") {
                    responseModel.idOcchielli = "-1";
                }
                else if (tipo == "CUCITURA") {
                    responseModel.idCuciture = "-1";
                }
                else if (tipo == "ELETTROSALDATURA") {
                    responseModel.idElettrosaldature = "-1";
                }
                else if (tipo == "ASOLA") {
                    responseModel.idAsole = "-1";
                }
                else if (tipo == "PLASTIFICAZIONE") {
                    responseModel.idPlastificazioni1 = "-1";
                }
                else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                    responseModel.idPlastificazioni2 = "-1";
                }
                else if (tipo == "COPERTINA") {
                    responseModel.idCopertine = "-1";
                }
            }
        }
    }

    hideOrShowRadComboItem(parameterList, tipo, id, hideOrShow, responseModel) {
        //Recupero delle info sulla combo
        let selected = false;
        for (let parameter of parameterList) {
            //Se l'elemento non è il valore 'Scegli' (-1) o vuoto, non bisogna considerarlo
            //Tranne per la copertina, dove -1 corrisponde all'autocopertinato, che può essere escluso
            if (tipo != "COPERTINA" && (parameter.chiave == "-1" || parameter.chiave == null)) {
                continue;
            }
            else {
                var idElemento;

                if (tipo == "CARTA"
                    || tipo == "CARTA_COPERTINA"
                    || (this.Macrocategory == "ETICHETTE" && tipo == "FORMATO")
                    || (this.Macrocategory == "STAMPA_DIRETTA" && tipo == "FORMATO")
                    || (this.Macrocategory == "PANNELLI" && tipo == "FORMATO")
                    || (this.Macrocategory == "BANDIERE" && tipo == "FORMATO")
                    || (this.Macrocategory == "MANIFESTI" && tipo == "FORMATO")
                    || (this.Macrocategory == "BANNER" && tipo == "FORMATO")
                    || (this.Macrocategory == "ADESIVI" && tipo == "FORMATO")) {
                    var data = parameter.chiave.split("_");
                    idElemento = data[0];
                }
                else if (tipo == "COPERTINA") {
                    if (parameter.chiave == "0") //Caso dell'autocopertinato
                    {
                        //Il value dell'option della combo per l'autocopertina è il valore vuoto,
                        //inveCe per le regole il valore dell'autocopertinato è -1, quindi occorre una conversione
                        idElemento = "-1";
                    }
                    else {
                        idElemento = parameter.chiave;
                    }
                }
                else {
                    idElemento = parameter.chiave;
                }

                if (hideOrShow == "show") {
                    if (idElemento == id) {
                        parameter.isVisible = true;
                        if (selected == false) {
                            if (tipo == "RILEGATURA") {
                                if (responseModel.idRilegature == "-1") {
                                    responseModel.idRilegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "MATERIALE_FLESSIBILE") {
                                if (responseModel.idMaterialiFlessibili == "-1") {
                                    responseModel.idMaterialiFlessibili = parameter.chiave;
                                }
                            }
                            else if (tipo == "SUPPORTO_RIGIDO") {
                                if (responseModel.idSupportiRigidi == "-1") {
                                    responseModel.idSupportiRigidi = parameter.chiave;
                                }
                            }
                            else if (tipo == "OCCHIELLATURA") {
                                if (responseModel.idOcchielli == "-1") {
                                    responseModel.idOcchielli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CUCITURA") {
                                if (responseModel.idCuciture == "-1") {
                                    responseModel.idCuciture = parameter.chiave;
                                }
                            }
                            else if (tipo == "ELETTROSALDATURA") {
                                if (responseModel.idElettrosaldature == "-1") {
                                    responseModel.idElettrosaldature = parameter.chiave;
                                }
                            }
                            else if (tipo == "ASOLA") {
                                if (responseModel.idAsole == "-1") {
                                    responseModel.idAsole = parameter.chiave;
                                }
                            }
                            else if (tipo == "PIEGATURA") {
                                if (responseModel.idPiegature == "-1") {
                                    responseModel.idPiegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "FUSTELLATURA") {
                                if (responseModel.idTagli == "-1") {
                                    responseModel.idTagli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA") {
                                var data = responseModel.idCarte1.split("_");
                                let idCarta = data[0];

                                if (idCarta == "-1") {
                                    responseModel.idCarte1 = parameter.chiave;
                                    responseModel.grammature1 = parameter.subElements;
                                    responseModel.idGrammature1 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA") {
                                if (responseModel.idGrammature1 == "-1") {
                                    responseModel.idGrammature1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA_COPERTINA") {
                                var data = responseModel.idCarte2.split("_");
                                let idCarta = data[0];

                                if (idCarta == "-1") {
                                    responseModel.idCarte2 = parameter.chiave;
                                    responseModel.grammature2 = parameter.subElements;
                                    responseModel.idGrammature2 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                                if (responseModel.idGrammature2 == "-1") {
                                    responseModel.idGrammature2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "FORMATO") {
                                if (responseModel.idFormati == "-1") {
                                    responseModel.idFormati = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE") {
                                if (responseModel.idPlastificazioni1 == "-1") {
                                    responseModel.idPlastificazioni1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                                if (responseModel.idPlastificazioni2 == "-1") {
                                    responseModel.idPlastificazioni2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "COPERTINA") {
                                if (responseModel.idCopertine == "-1") {
                                    responseModel.idCopertine = parameter.chiave;
                                }
                            }
                            else if (tipo == "BIANCO_COPRENTE") {
                                if (responseModel.idBiancoCoprente == "-1") {
                                    responseModel.idBiancoCoprente = parameter.chiave;
                                }
                            }
                            selected = true;
                        }
                    }
                    else {
                        if (selected == false) {
                            if (tipo == "RILEGATURA") {
                                if (responseModel.idRilegature == "-1") {
                                    responseModel.idRilegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "MATERIALE_FLESSIBILE") {
                                if (responseModel.idMaterialiFlessibili == "-1") {
                                    responseModel.idMaterialiFlessibili = parameter.chiave;
                                }
                            }
                            else if (tipo == "SUPPORTO_RIGIDO") {
                                if (responseModel.idSupportiRigidi == "-1") {
                                    responseModel.idSupportiRigidi = parameter.chiave;
                                }
                            }
                            else if (tipo == "OCCHIELLATURA") {
                                if (responseModel.idOcchielli == "-1") {
                                    responseModel.idOcchielli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CUCITURA") {
                                if (responseModel.idCuciture == "-1") {
                                    responseModel.idCuciture = parameter.chiave;
                                }
                            }
                            else if (tipo == "ELETTROSALDATURA") {
                                if (responseModel.idElettrosaldature == "-1") {
                                    responseModel.idElettrosaldature = parameter.chiave;
                                }
                            }
                            else if (tipo == "ASOLA") {
                                if (responseModel.idAsole == "-1") {
                                    responseModel.idAsole = parameter.chiave;
                                }
                            }
                            else if (tipo == "PIEGATURA") {
                                if (responseModel.idPiegature == "-1") {
                                    responseModel.idPiegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "FUSTELLATURA") {
                                if (responseModel.idTagli == "-1") {
                                    responseModel.idTagli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA") {
                                var data = responseModel.idCarte1.split("_");
                                let idCarta = data[0];

                                if (idCarta == "-1") {
                                    responseModel.idCarte1 = parameter.chiave;
                                    responseModel.grammature1 = parameter.subElements;
                                    responseModel.idGrammature1 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA") {
                                if (responseModel.idGrammature1 == "-1") {
                                    responseModel.idGrammature1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA_COPERTINA") {
                                var data = responseModel.idCarte2.split("_");
                                let idCarta = data[0];

                                if (idCarta == "-1") {
                                    responseModel.idCarte2 = parameter.chiave;
                                    responseModel.grammature2 = parameter.subElements;
                                    responseModel.idGrammature2 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                                if (responseModel.idGrammature2 == "-1") {
                                    responseModel.idGrammature2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "FORMATO") {
                                if (responseModel.idFormati == "-1") {
                                    responseModel.idFormati = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE") {
                                if (responseModel.idPlastificazioni1 == "-1") {
                                    responseModel.idPlastificazioni1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                                if (responseModel.idPlastificazioni2 == "-1") {
                                    responseModel.idPlastificazioni2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "COPERTINA") {
                                if (responseModel.idCopertine == "-1") {
                                    responseModel.idCopertine = parameter.chiave;
                                }
                            }

                            selected = true;
                        }
                    }
                }
                else if (hideOrShow == "hide") {
                    if (idElemento == id) {
                        parameter.isVisible = false;
                    }
                    else {
                        if (selected == false && parameter.isVisible == true) {
                            if (tipo == "RILEGATURA") {
                                if (responseModel.idRilegature == id) {
                                    responseModel.idRilegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "MATERIALE_FLESSIBILE") {
                                if (responseModel.idMaterialiFlessibili == id) {
                                    responseModel.idMaterialiFlessibili = parameter.chiave;
                                }
                            }
                            else if (tipo == "SUPPORTO_RIGIDO") {
                                if (responseModel.idSupportiRigidi == id) {
                                    responseModel.idSupportiRigidi = parameter.chiave;
                                }
                            }
                            else if (tipo == "OCCHIELLATURA") {
                                if (responseModel.idOcchielli == id) {
                                    responseModel.idOcchielli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CUCITURA") {
                                if (responseModel.idCuciture == id) {
                                    responseModel.idCuciture = parameter.chiave;
                                }
                            }
                            else if (tipo == "ELETTROSALDATURA") {
                                if (responseModel.idElettrosaldature == id) {
                                    responseModel.idElettrosaldature = parameter.chiave;
                                }
                            }
                            else if (tipo == "ASOLA") {
                                if (responseModel.idAsole == id) {
                                    responseModel.idAsole = parameter.chiave;
                                }
                            }
                            else if (tipo == "PIEGATURA") {
                                if (responseModel.idPiegature == id) {
                                    responseModel.idPiegature = parameter.chiave;
                                }
                            }
                            else if (tipo == "FUSTELLATURA") {
                                if (responseModel.idTagli == id) {
                                    responseModel.idTagli = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA") {
                                var data = responseModel.idCarte1.split("_");
                                let idCarta = data[0];

                                if (idCarta == id) {
                                    responseModel.idCarte1 = parameter.chiave;
                                    responseModel.grammature1 = parameter.subElements;
                                    responseModel.idGrammature1 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA") {
                                if (responseModel.idGrammature1 == id) {
                                    responseModel.idGrammature1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "CARTA_COPERTINA") {
                                var data = responseModel.idCarte2.split("_");
                                let idCarta = data[0];

                                if (idCarta == id) {
                                    responseModel.idCarte2 = parameter.chiave;
                                    responseModel.grammature2 = parameter.subElements;
                                    responseModel.idGrammature2 = parameter.wrap_valore;
                                }
                            }
                            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                                if (responseModel.idGrammature2 == id) {
                                    responseModel.idGrammature2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "FORMATO") {
                                if (this.Macrocategory == "ETICHETTE"
                                    || this.Macrocategory == "ADESIVI"
                                    || this.Macrocategory == "PANNELLI"
                                    || this.Macrocategory == "MANIFESTI"
                                    || this.Macrocategory == "STAMPA_DIRETTA"
                                    || this.Macrocategory == "BANDIERE"
                                    || this.Macrocategory == "BANNER") {
                                    var data = responseModel.idFormati.split("_");
                                    let idFormato = data[0];
                                    if (idFormato == id) {
                                        responseModel.idFormati = parameter.chiave;
                                    }
                                }
                                else {
                                    if (responseModel.idFormati == id) {
                                        responseModel.idFormati = parameter.chiave;
                                    }
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE") {
                                if (responseModel.idPlastificazioni1 == id) {
                                    responseModel.idPlastificazioni1 = parameter.chiave;
                                }
                            }
                            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                                if (responseModel.idPlastificazioni2 == id) {
                                    responseModel.idPlastificazioni2 = parameter.chiave;
                                }
                            }
                            else if (tipo == "COPERTINA") {
                                if (responseModel.idCopertine == id) {
                                    responseModel.idCopertine = parameter.chiave;
                                }
                            }
                            else if (tipo == "BIANCO_COPRENTE") {
                                if (responseModel.idBiancoCoprente == id) {
                                    responseModel.idBiancoCoprente = parameter.chiave;
                                }
                            }
                            selected = true;
                        }
                    }
                }
            }
        }
        if (selected == false) {
            if (tipo == "RILEGATURA") {
                responseModel.idRilegature = "-1";
            }
            else if (tipo == "MATERIALE_FLESSIBILE") {
                responseModel.idMaterialiFlessibili = "-1";
            }
            else if (tipo == "SUPPORTO_RIGIDO") {
                responseModel.idSupportiRigidi = "-1";
            }
            else if (tipo == "OCCHIELLATURA") {
                responseModel.idOcchielli = "-1";
            }
            else if (tipo == "CUCITURA") {
                responseModel.idCuciture = "-1";
            }
            else if (tipo == "ELETTROSALDATURA") {
                responseModel.idElettrosaldature = "-1";
            }
            else if (tipo == "ASOLA") {
                responseModel.idAsole = "-1";
            }
            else if (tipo == "PIEGATURA") {
                responseModel.idPiegature = "-1";
            }
            else if (tipo == "FUSTELLATURA") {
                responseModel.idTagli = "-1";
            }
            else if (tipo == "CARTA") {
                responseModel.idCarte1 = "-1";
                responseModel.grammature1 = new Array<Object>();
                responseModel.idGrammature1 = "-1";
            }
            else if (tipo == "GRAMMATURA_CARTA") {
                responseModel.idGrammature1 = "-1";
            }
            else if (tipo == "CARTA_COPERTINA") {
                responseModel.idCarte2 = "-1";
                responseModel.grammature2 = new Array<Object>();
                responseModel.idGrammature2 = "-1";
            }
            else if (tipo == "GRAMMATURA_CARTA_COPERTINA") {
                responseModel.idGrammature2 = "-1";
            }
            else if (tipo == "PLASTIFICAZIONE") {
                responseModel.idPlastificazioni1 = "-1";
            }
            else if (tipo == "PLASTIFICAZIONE_COPERTINA") {
                responseModel.idPlastificazioni2 = "-1";
            }
            else if (tipo == "FORMATO") {
                responseModel.idFormati = "-1";
            }
            else if (tipo == "COPERTINA") {
                responseModel.idCopertine = "-1";
            }
            else if (tipo == "BIANCO_COPRENTE") {
                responseModel.idBiancoCoprente = "0";
            }
        }
    }

    /// <param name="tipo">"PF" </param>
    /// <param name="categoria">"FINITURA"</param>
    /// <param name="sezione">"FORMATO"</param>
    /// <param name="macroCategoria">"EDITORIA"</param>
    /// <param name="elemento">null </param>
    /// <param name="sottoElemento">null</param>
    FindRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel) {
        let regole = new Array();

        for (let regola of responseModel.listaRegole) {
            //console.log("FindRegole(" + tipo + "," + categoria + "," + sezione + "," + macroCategoria + "," + elemento + "," + sottoElemento + ")");

            if (regola.Tipo == tipo
                && regola.Categoria_1 == categoria && regola.Sezione_1 == sezione
                && regola.Macro_Categoria_1 == macroCategoria) //Elementi primari
            {
                //console.log("regola (" + regola.Tipo + "," + regola.Categoria_1 + "," + regola.Sezione_1 + "," + regola.Macro_Categoria_1 + "," + regola.Id_Elemento_1 + "," + regola.Id_Elemento_Sottochiave_1 + ")");
                if (elemento != null && regola.Id_Elemento_1 == elemento) {
                    if (sottoElemento != null && regola.Id_Elemento_Sottochiave_1 == sottoElemento) {
                        regole.push(regola);
                    }
                    else if (sottoElemento == null || regola.Id_Elemento_Sottochiave_1 == 0) {  //-- If Sotto-Elemento	is set to nessuna in regole, to remove entire element
                        regole.push(regola);
                    }
                }
                else if (elemento == null) //se non è stato indicato un id, vengono prese tutte le regole per la sezione in oggetto
                {
                    regole.push(regola);
                }
            }

        }
        //console.log(regole.length);
        return regole
    }

    CheckMacroCategoria(regola, macroCategoria) {
        var result = false;

        if (regola.Macro_Categoria_2 == null || regola.Macro_Categoria_2 == "") {
            result = true;
        }
        else if (regola.Macro_Categoria_2 != null && regola.Macro_Categoria_2.toUpperCase() == macroCategoria.toUpperCase()) {
            result = true;
        }

        return result;
    }

    ApplicaRegoleLavorazioniAccessorie(tipo, macroCategoria, responseModel, responseModelOtherProduct = []) {
        let categoria: string = "ACCESSORIA";
        let sezione: string = "";
        let elemento: string;
        let sottoElemento: string;

        //Lettura della lista delle lavorazioni accessorie
        //Vengono applicate le regole per ogni lavorazione accessoria
        for (let lavorazioneAccessoria of responseModel.lavorazioniAccessorie) {
            elemento = lavorazioneAccessoria.id;

            let tipoLavorazioneAccessoria;

            if (lavorazioneAccessoria.tipo == "0") {
                tipoLavorazioneAccessoria = "check";
            }
            else if (lavorazioneAccessoria.tipo == "2") {
                tipoLavorazioneAccessoria = "select";
            }
            else if (lavorazioneAccessoria.tipo == "6") {
                tipoLavorazioneAccessoria = "textarea";
            }

            //Per le lavorazioni di tipo combo bisogna leggere il valore della select
            //Invece se si tratta di una check bisogna vedere se è checkata o meno.
            if (tipoLavorazioneAccessoria == "check") //check
            {
                sottoElemento = null;
                //se la lavorazione è stata checkata allora vengono applicate le eventuali regole associate
                if (lavorazioneAccessoria.lavorazioneCheckValue == false || lavorazioneAccessoria.lavorazioneCheckValue == "false" || lavorazioneAccessoria.tipoSelezione == 'nascosto') {
                    sottoElemento = "1"; //Corrispone a No nella regola
                }
                else if (lavorazioneAccessoria.lavorazioneCheckValue) {
                    sottoElemento = "2"; //Corrispone a Si nella regola
                }

                this.ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct);
            }
            else if (tipoLavorazioneAccessoria == "select") //combo
            {
                sottoElemento = this.getComboValue("ACCESSORIA", lavorazioneAccessoria.valore, lavorazioneAccessoria);

                this.ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct);
            }
            else if (tipoLavorazioneAccessoria = "textarea") {
                sottoElemento = '0';
                this.ApplicaRegole(tipo, categoria, sezione, macroCategoria, elemento, sottoElemento, responseModel, responseModelOtherProduct);
            }
        }
    }
    getComboValue(attributo, id, lavorazioneAccessoria) {
        var value = "";

        //Controllo prima se si tratta di una lavorazione accessoria, dato che la loro gestione è uguale per tutte le macrocategorie
        if (attributo == "ACCESSORIA") {
            //Lettura di tutta la lista delle lavorazioni accessorie
            for (let varianti of lavorazioneAccessoria.valori) {
                //console.log(varianti)
                var item = varianti;
                var display = varianti.isVisible;

                //Lettura dell'id della lavorazione corrente
                var idLav = item.chiave;
                var tipoLavorazione = lavorazioneAccessoria.tipo;
                var idLavAcc = lavorazioneAccessoria.valore;

                if (id == idLav) {
                    //Se la riga non è mostrata viene considerata come non selezionata
                    if (display == false) {
                        value = "-1";
                    }
                    else {
                        //Lettura del valore selezionato nella select
                        value = idLav;
                        break;
                    }
                }
            }
            return value;
        }
    }

    hideOrShowLavorazioneAccessoria(idLavorazione, idVariante, hideOrShow, responseModel, responseModelOtherProduct = []) {
        for (let lavorazioneAccessoria of responseModel.lavorazioniAccessorie) {
            var tipoLavorazione = lavorazioneAccessoria.tipo;
            var idLavAcc = lavorazioneAccessoria.id;

            if (idLavAcc == idLavorazione) {
                if (tipoLavorazione == "2") {
                    let comboItemNumber = -1;

                    if (idVariante == null || idVariante == 0) {
                        if (hideOrShow == "hide") {
                            lavorazioneAccessoria.isVisible = false;
                        }
                        else if (hideOrShow == "show") {
                            lavorazioneAccessoria.isVisible = true;
                        }
                    }
                    else {
                        let selected = false;
                        for (let variante of lavorazioneAccessoria.valori) {
                            if (hideOrShow == "hide") {
                                if (variante.chiave == idVariante) {
                                    variante.isVisible = false;
                                    //-- If type is combobox and we want to hide just one combo option, we will send it's id
                                    comboItemNumber = idVariante;
                                }
                            }
                            else if (hideOrShow == "show") {
                                variante.isVisible = true;

                                if (selected == false) {
                                    if (lavorazioneAccessoria.valore == "-1") {
                                        lavorazioneAccessoria.valore = variante.chiave;
                                    }
                                    selected = true;
                                }
                            }
                        }
                        let firstVariableVisible = 0;
                        for (let variante of lavorazioneAccessoria.valori) {
                            if (firstVariableVisible == 0) {
                                if (variante.isVisible == true) {
                                    firstVariableVisible = variante.chiave;
                                }
                            }
                            if (lavorazioneAccessoria.valore == variante.chiave) {
                                if (variante.isVisible == true) {
                                    selected = true;
                                }
                            }
                        }
                        if (selected == false && firstVariableVisible == 0) {
                            lavorazioneAccessoria.valore = "-1";
                        }
                        else if (selected == false) {
                            lavorazioneAccessoria.valore = firstVariableVisible;
                        }
                    }

                    this.reflectChangesOnOtherProducts(responseModelOtherProduct, hideOrShow, lavorazioneAccessoria, comboItemNumber);
                }
                else {
                    if (hideOrShow == "hide") {
                        lavorazioneAccessoria.isVisible = false;
                    }
                    else if (hideOrShow == "show") {
                        lavorazioneAccessoria.isVisible = true;
                    }

                    this.reflectChangesOnOtherProducts(responseModelOtherProduct, hideOrShow, lavorazioneAccessoria);
                }
            }
        }
    }

    /*-- In other products we don't use lavorazzioniAccessorie object but gruppi,
         so for every change on one object we need to reflect it on the another one */
    reflectChangesOnOtherProducts(responseModelOtherProduct, hideOrShow, lavorazioneAccessoria, comboItemNumber = -1) {
        if (responseModelOtherProduct === undefined || responseModelOtherProduct.length == 0)
            return;

        var idLavorazione = lavorazioneAccessoria.id;

        let isFoundElement = false;
        //-- From gruppi obect get all varianti and convert it to Lavorazioni Accessorie model
        for (let group of responseModelOtherProduct) {
            for (let variante of group.varianti) {
                if (variante.id == idLavorazione) {
                    if (variante.tipo != '2' || comboItemNumber == -1) {
                        variante.isVisible = hideOrShow == "hide" ? false : true;
                        //-- If item from select we want to hide was selected before rule is applied on it, we are changing it's value
                        if (!variante.isVisible && (lavorazioneAccessoria.valore || lavorazioneAccessoria.valore == 0)) {
                            variante.intFormValue = lavorazioneAccessoria.valore;
                        }
                    }
                    else {
                        if (variante.valori) {
                            var comboOption = variante.valori.filter(x => x.chiave == comboItemNumber);
                            if (comboOption) {
                                comboOption.isVisible = hideOrShow == "hide" ? false : true;

                                //-- If selected element need to be hidden because of regola, we are selecting first visible element
                                if(!comboOption.isVisible)
                                {
                                    //  let value = lavorazioneAccessoria.valori.filter(x => x.isVisible == true)[0].chiave;
                                    //  if(variante.intFormValue)
                                     variante.intFormValue = lavorazioneAccessoria.valore;
                                }
                            }
                        }
                    }

                    isFoundElement = true;
                    break;
                }

            }
            //-- If variante is found, break both loops, because we don't need to look for any other variante
            if (isFoundElement) break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/document/widget/quoting/quoting-excluding.component.ts